import * as React from 'react'
import { SettingsPage } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getImports } from '@user/store/import/api'
import { useEffect } from 'react'
import { TitleContent } from './TitleContent/TitleContent'
import { ImportDataGrid } from '../ImportDataGrid/ImportDataGrid'
import { ImportUtilityModel } from '../AddImportUtilityDrawer/typings'

type Props = {
  onDrawerSave: (model: ImportUtilityModel) => void
}

export function ImportsPage(props: Props) {
  const { onDrawerSave } = props
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getImports())
  }, [dispatch])

  return (
    <SettingsPage
      title="Data Import Utility"
      titleContent={<TitleContent onDrawerSave={onDrawerSave} />}
      padding="0"
    >
      <ImportDataGrid />
    </SettingsPage>
  )
}
